const formatNumerals=a=>b=>b.replace(/[0-9]/g,b=>a[+b]);export default formatNumerals;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/number-converter/format-numerals.js
// module id = null
// module chunks = 